module.exports = __webpack_public_path__ + "static/media/sleep-well.7a42d132.jpg";